<template>
  <div class="w-full bg-white py-5 px-5 shadow-lg flex flex-col">
    <div class="w-36 pb-2 md:pb-0">
      <SecondaryButton
        :classes="'border-brand-mid-gray'"
        v-if="preview"
        @click="exitPreview"
      >
        <div class="flex items-center">
          <ChevronLeftIcon class="text-brand-green w-5 h-5 mr-1" />
          <p class="text-sm">Exit preview</p>
        </div>
      </SecondaryButton>
    </div>
    <div class="hidden md:block">
      <div class="flex flex-row md:w-1/2 m-auto">
        <div class="flex-1 text-center">
          <h5
            :class="[
              'cursor-pointer',
              active === 'application'
                ? 'text-brand-green'
                : 'text-brand-mid-gray'
            ]"
          >
            Application
          </h5>
        </div>
        <div class="flex-1 text-center">
          <h5
            :class="[
              'cursor-pointer',
              active === 'account' ? 'text-brand-green' : 'text-brand-mid-gray'
            ]"
          >
            Account
          </h5>
        </div>
        <div class="flex-1 text-center" v-if="verify">
          <h5
            :class="[
              'cursor-pointer',
              active === 'verify' ? 'text-brand-green' : 'text-brand-mid-gray'
            ]"
          >
            Verify
          </h5>
        </div>
        <div class="flex-1 text-center" v-if="income">
          <h5
            :class="[
              'cursor-pointer',
              active === 'income' ? 'text-brand-green' : 'text-brand-mid-gray'
            ]"
          >
            Income
          </h5>
        </div>
        <div class="flex-1 text-center" v-if="pay">
          <h5
            :class="[
              'cursor-pointer',
              active === 'pay' ? 'text-brand-green' : 'text-brand-mid-gray'
            ]"
          >
            Payment
          </h5>
        </div>
      </div>
    </div>

    <div class="block md:hidden">
      <div class="flex flex-row md:w-1/2 m-auto">
        <div class="flex-1 text-center">
          <h5
            :class="[
              'cursor-pointer',
              active === 'application'
                ? 'text-brand-green'
                : 'text-brand-mid-gray'
            ]"
          >
            Application
          </h5>
        </div>
        <div class="flex-1 text-center">
          <h5
            :class="[
              'cursor-pointer',
              active === 'account' ? 'text-brand-green' : 'text-brand-mid-gray'
            ]"
          >
            Account
          </h5>
        </div>
        <div class="flex-1 text-center" v-if="verify">
          <h5
            :class="[
              'cursor-pointer',
              active === 'verify' ? 'text-brand-green' : 'text-brand-mid-gray'
            ]"
          >
            Verify
          </h5>
        </div>
        <div class="flex-1 text-center" v-if="income">
          <h5
            :class="[
              'cursor-pointer',
              active === 'income' ? 'text-brand-green' : 'text-brand-mid-gray'
            ]"
          >
            Income
          </h5>
        </div>
        <div class="flex-1 text-center" v-if="pay">
          <h5
            :class="[
              'cursor-pointer',
              active === 'pay' ? 'text-brand-green' : 'text-brand-mid-gray'
            ]"
          >
            Payment
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ChevronLeftIcon } from "@heroicons/vue/outline"
export default {
  components: {
    ChevronLeftIcon
  },
  props: {
    active: {
      type: String,
      default: "application"
    },
    verify: {
      type: Boolean,
      default: false
    },
    income: {
      type: Boolean,
      default: false
    },
    pay: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    exitPreview() {
      this.$router.go(-1)
    }
  }
}
</script>
